import {BaseWidgetSettings} from "./base-settings.type";
import {ComponentVariant} from "./component-variants";
import {IBaseDatetimeBarData, IBaseDatetimeBarDesign} from "../../structural";

export type DateTimeBarSettings = {
  dateTimeBarData?: IBaseDatetimeBarData; // todo use this, deprecate the text, color
  dateTimeBarDesign?: IBaseDatetimeBarDesign; // todo use this, deprecate the text, color
  variant?: ComponentVariant;
} & BaseWidgetSettings;
